<template>
    <router-view></router-view>
<!--  <h1>Startseite</h1>-->
<!--  <h4>Links zu weiteren Views</h4>-->
<!--  <div id="nav">-->
<!--    <router-link :to="{ name: 'test' }">Home</router-link> |-->
<!--&lt;!&ndash;    <router-link :to="{ name: 'Test' }">Test</router-link>&ndash;&gt;-->
<!--  </div>-->
  <div>
    <Home />
  </div>
</template>

<script>
import Home from './views/Home.vue';

export default {
  name: 'App',
  components: {
    Home,
  },
};
</script>
